module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Up-left-73dd4f413106485bb00672345df61081.svg";